import { Paper, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";


import { useNavigate } from "react-router-dom";
import configUrls from "../../../config/configUrls";
import errorFormat from "../../../utils/errorFormat";


import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { ISprocessoAtribuir, ProcessoAtribuir } from "../../../types/processo/ProcessoAtribuir";
import { ISusuario, Usuario } from "../../../types/usuario/Usuario";
import { useCreateDocumento1Mutation } from "../../iniciarDocumento/createDocumento/documentoApiSlice";
import { addDocumentoProcessoSelecioadoSlice } from "../processoSelecionadoSlice";
import { ProcessoAtribuirForm } from "./ProcessoAtribuirForm";
import { useAddAtribuirResponsavelMutation } from "../processoApiSlice";


export const ProcessoAtribuirCreate = () => {


    const [processoAtribuir, setProcessoAtribuir] = useState<ProcessoAtribuir>(ISprocessoAtribuir);
    const [interessadoSelecionadoTemp, setInteressadoSelecionadoTemp] = useState<Usuario>(ISusuario);

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createResponsavel, status] = useAddAtribuirResponsavelMutation();
    const navigate = useNavigate();


    //ler do RTK o processo selecionado    
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!processoSelecionado) {
            // navigate(configUrls.PROCESSO_LIST_RT);
            window.location.href = configUrls.PROCESSO_LIST_RT
        } else {
            setProcessoAtribuir((prev) => ({
                ...prev,
                processoId: processoSelecionado.id
            }));
        }
    }, []);


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setProcessoAtribuir((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    const handletxtInteressadoChange = (usuario: Usuario) => {
        setInteressadoSelecionadoTemp(usuario);
        setProcessoAtribuir((prev) => ({
            ...prev,
            usuario: usuario,
        }));
    };


    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        const params = {
            processoId: processoAtribuir.processoId,
            observacao: processoAtribuir.observacao ?? undefined,
            usuarioId: processoAtribuir.usuario.id,
        };

        await createResponsavel(params);
    }

    useEffect(() => {

        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            // dispatch(addDocumentoProcessoSelecioadoSlice(status.data));
            navigate(-1);
            // setDocumento(ISdocumento);    
        }

    }, [status]);


    return (

        <>
            <Paper>
                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Atribuir o Processo: {processoSelecionado?.numeroProcesso} para:
                </Typography>



                <ProcessoAtribuirForm
                    data={processoAtribuir}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    handletxtInteressadoChange={handletxtInteressadoChange}
                    interessadoValueTmp={interessadoSelecionadoTemp}
                />

            </Paper>
        </>
    );
};
